/*=========================================================================================
  File Name: organizationActions.js
  Description: Vuex Store - organization actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    getOrganizations({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/organizations', method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    createOrganization({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/organizations/create', method: 'GET'})
                .then((user) => {
                    resolve(user.data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    storeOrganization({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/organizations/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    if(data.organization.status === 1) {
                        state.basicOrganizationData.logo = null;
                        state.basicOrganizationData.logo_b = null;
                        state.basicOrganizationData.logo_s = null;

                        state.basicOrganizationData.logo_big = null;
                        state.basicOrganizationData.logo_big_b = null;
                        state.basicOrganizationData.logo_big_s = null;
                    }

                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    editOrganization({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/organizations/edit/' + id, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    updateOrganization({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
            axios({
                url: state.API_URL + '/auth/organization/organizations/update/' + payload.id,
                data: payload,
                method: 'POST'
            })
                .then(({data}) => {
                    if (data.web_request === null) {
                        payload.notify({
                            time: 3500,
                            text: data.message,
                            iconPack: 'feather',
                            icon: 'icon-check',
                            color: 'success'
                        });

                        commit('organization_updated', data);
                        resolve();
                    } else {
                        axios({url: data.web_request.url, data: {data: data, payload: payload}, method: 'POST'})
                            .then(({data}) => {
                                payload.notify({
                                    time: 3500,
                                    text: data.message,
                                    iconPack: 'feather',
                                    icon: 'icon-check',
                                    color: 'success'
                                });

                                commit('organization_updated', data.basicOrganizationData);
                                resolve();
                            });
                    }
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    getOrganizationOptions() {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/options', method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    setActiveOrganization({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/set-active-organization', data: payload, method: 'POST'})
                .then(({data}) => {
                    if(data.message){
                        payload.notify({
                            time: 3500,
                            text: data.message,
                            iconPack: 'feather',
                            icon: 'icon-check',
                            color: 'success'
                        });

                        commit('organization_updated', data);
                    }

                    resolve();
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    }
};
